import theme from '@styles/theme';
export default {
  socialMediaContainer: {},
  socialMediaItemsContainer: {
    display: 'flex',
    flexDirection: ['column', 'row'],
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center',
    padding: ['0', '0', '16px 0 12px 0']
  },
  socialMediaPartContainer: {
    display: 'flex',
    flexDirection: ['column', 'row'],
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'center'
  },
  socialMediaItemLinkContainer: {
    margin: ['24px 12px 0', '24px 12px 0', '24px 12px 0', '24px 12px 0', '24px 0.625vw 0']
  },
  socialMediaItemContainer: {
    width: ['87.2vw', '87.2vw', '45.3125vw', '45.3125vw', '18.90625vw'],
    height: ['87.2vw', '87.2vw', '45.3125vw', '45.3125vw', '18.90625vw'],
    position: 'relative',
    img: {
      position: 'relative',
      transition: 'opacity .15s',
      height: '100%',
      width: '100%'
    }
  },
  socialMediaItemContainerLink: {
    '&:focus-visible': {
      width: '100%',
      height: '100%',
      zIndex: 1,
      display: 'block'
    }
  },
  socialMediaTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: ['8.53333333vw 8.53333333vw 12.4675325vw', '8.53333333vw 8.53333333vw 12.4675325vw', '5.20833333vw 5.20833333vw 7.29166667vw', '5.20833333vw 5.20833333vw 7.29166667vw', '2.5vw 2.5vw 3.75vw'],
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    svg: {
      width: ['14.6666667vw', '14.6666667vw', '7.16145833vw', '7.16145833vw', '2.86458333vw']
    },
    'h4.headings.heading__four.mobile': {
      flexGrow: 1,
      fontSize: [theme.fontSizes.h4, theme.fontSizes.h2, theme.fontSizes.h3, theme.fontSizes.h3, theme.fontSizes.h5, theme.fontSizes.h4, theme.fontSizes.h3, theme.fontSizes.h3]
    }
  }
};